import { render, staticRenderFns } from "./section_order.vue?vue&type=template&id=755c93e6&"
import script from "./section_order.vue?vue&type=script&lang=js&"
export * from "./section_order.vue?vue&type=script&lang=js&"
import style0 from "./section_order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports